module.exports = __webpack_public_path__ + "img/chatbot-o.cacf22de.png";